export default function Spinner(): JSX.Element {
  return (
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Učitavam...</span>
    </div>
  );
}
